<div *ngIf="data?.asOfDate;else noData">
    <div class="toggle-container">
        <c11n-segmented-control *ngIf="profileData?.isETF" size="small" color="ink" legendText="Market Price/Nav Toggle"
            class="quarterly-toggle-width" (stateChange)="onChange($event)">
            <c11n-segment id="QuarterlyMarket" labelText="Market Price" class="c11n-segmented-control__segment--active">
                <input c11n-segment-input type="radio" id="market-quarterly" name="segment-group-2"
                    [value]="'marketPrice'" data-rpa-tag-id="pf-qatr-buttonMarket">
            </c11n-segment>
            <c11n-segment id="Regular" labelText="Nav">
                <input c11n-segment-input type="radio" id="regular-quarterly" name="segment-group-2" [value]="'regular'"
                    data-rpa-tag-id="pf-qatr-buttonNav">
            </c11n-segment>
        </c11n-segmented-control>
        <p class="disclaimer" data-rpa-tag-id="quaterlyAfterTaxDate">as of {{ data?.asOfDate | ESTPipe | DashIfEmpty }}
        </p>
    </div>
    <div style="position: relative;">
        <div class="table-container">
            <table scrollingTable aria-label="Quarterly after tax">
                <thead>
                    <tr>
                        <th scope="col">
                            <p class="fund-name">{{data?.name | DashIfEmpty}}<sup
                                    *ngIf="profileData?.ticker=='VPGDX'">{{performanceFootNote?.id}}</sup></p>
                        </th>
                        <th scope="col">1-yr</th>
                        <th scope="col">3-yr</th>
                        <th scope="col">5-yr</th>
                        <th scope="col">10yr</th>
                        <th scope="col">
                            <p style="white-space: nowrap;">Since inception</p>
                            <p data-rpa-tag-id="inceptionDate">{{ data?.sinceInceptionAsOfDate | ESTPipe | DashIfEmpty
                                }}</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="col">{{data?.[type]?.beforeTax?.name}}</th>
                        <td scope="col" data-rpa-tag-id="oneYrPctBeforeTax">{{data?.[type]?.beforeTax?.oneYrPct |
                            VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="threeYrPctBeforeTax">{{data?.[type]?.beforeTax?.threeYrPct |
                            VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="fiveYrPctBeforeTax">{{data?.[type]?.beforeTax?.fiveYrPct |
                            VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="tenYrPctBeforeTax">{{data?.[type]?.beforeTax?.tenYrPct |
                            VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="inceptionPercentageBeforeTax">
                            {{data?.[type]?.beforeTax?.sinceInceptionPct | VMFPercent | DashIfEmpty}}</td>
                    </tr>
                    <tr>
                        <th scope="col">{{data?.[type]?.afterTaxOnDistribution?.name}}</th>
                        <td scope="col" data-rpa-tag-id="oneYrPctAfterTaxOnDistribution">
                            {{data?.[type]?.afterTaxOnDistribution?.oneYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="threeYrPctAfterTaxOnDistribution">
                            {{data?.[type]?.afterTaxOnDistribution?.threeYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="fiveYrPctAfterTaxOnDistribution">
                            {{data?.[type]?.afterTaxOnDistribution?.fiveYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="tenYrPctAfterTaxOnDistribution">
                            {{data?.[type]?.afterTaxOnDistribution?.tenYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="inceptionPercentageAfterTaxOnDistribution">
                            {{data?.[type]?.afterTaxOnDistribution?.sinceInceptionPct | VMFPercent | DashIfEmpty}}</td>
                    </tr>
                    <tr>
                        <th scope="col">{{data?.[type]?.afterTaxOnDistributionFundShares?.name}}</th>
                        <td scope="col" data-rpa-tag-id="oneYrPctAfterTaxOnDistributionFundShares">
                            {{data?.[type]?.afterTaxOnDistributionFundShares?.oneYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="threeYrPctAfterTaxOnDistributionFundShares">
                            {{data?.[type]?.afterTaxOnDistributionFundShares?.threeYrPct | VMFPercent | DashIfEmpty}}
                        </td>
                        <td scope="col" data-rpa-tag-id="fiveYrPctAfterTaxOnDistributionFundShares">
                            {{data?.[type]?.afterTaxOnDistributionFundShares?.fiveYrPct | VMFPercent | DashIfEmpty}}
                        </td>
                        <td scope="col" data-rpa-tag-id="tenYrPctAfterTaxOnDistributionFundShares">
                            {{data?.[type]?.afterTaxOnDistributionFundShares?.tenYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="inceptionPercentageAfterTaxOnDistributionFundShares">
                            {{data?.[type]?.afterTaxOnDistributionFundShares?.sinceInceptionPct | VMFPercent |
                            DashIfEmpty}}</td>
                    </tr>
                    <tr class="benchmark-title">
                        <th scope="col-group" class="sub-title">
                            <p>{{data?.benchmarkName | DashIfEmpty}}</p>
                        </th>
                        <td colspan="5"></td>
                    </tr>
                    <tr>
                        <th scope="col">{{data?.benchmark?.beforeTax?.name}}</th>
                        <td scope="col" data-rpa-tag-id="oneYrPctBenchmkBeforeTax">
                            {{data?.benchmark?.beforeTax?.oneYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="threeYrPctBenchmkBeforeTax">
                            {{data?.benchmark?.beforeTax?.threeYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="fiveYrPctBenchmkBeforeTax">
                            {{data?.benchmark?.beforeTax?.fiveYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="tenYrPctBenchmkBeforeTax">
                            {{data?.benchmark?.beforeTax?.tenYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="inceptionPercentageBenchmkBeforeTax">
                            {{data?.benchmark?.beforeTax?.sinceInceptionPct | VMFPercent | DashIfEmpty}}</td>
                    </tr>
                    <tr>
                        <th scope="col">{{data?.benchmark?.afterTaxOnDistribution?.name}}</th>
                        <td scope="col" data-rpa-tag-id="oneYrPctBenchmkAfterTaxOnDistribution">
                            {{data?.benchmark?.afterTaxOnDistribution?.oneYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="threeYrPctBenchmkAfterTaxOnDistribution">
                            {{data?.benchmark?.afterTaxOnDistribution?.threeYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="fiveYrPctBenchmkAfterTaxOnDistribution">
                            {{data?.benchmark?.afterTaxOnDistribution?.fiveYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="tenYrPctBenchmkAfterTaxOnDistribution">
                            {{data?.benchmark?.afterTaxOnDistribution?.tenYrPct | VMFPercent | DashIfEmpty}}</td>
                        <td scope="col" data-rpa-tag-id="inceptionPercentageBenchmkAfterTaxOnDistribution">
                            {{data?.benchmark?.afterTaxOnDistribution?.sinceInceptionPct | VMFPercent | DashIfEmpty}}
                        </td>
                    </tr>
                    <tr>
                        <th scope="col">{{data?.benchmark?.afterTaxOnDistributionFundShares?.name}}</th>
                        <td scope="col" data-rpa-tag-id="oneYrPctBenchmkAfterTaxOnDistributionFundShares">
                            {{data?.benchmark?.afterTaxOnDistributionFundShares?.oneYrPct | VMFPercent | DashIfEmpty}}
                        </td>
                        <td scope="col" data-rpa-tag-id="threeYrPctBenchmkAfterTaxOnDistributionFundShares">
                            {{data?.benchmark?.afterTaxOnDistributionFundShares?.threeYrPct | VMFPercent | DashIfEmpty}}
                        </td>
                        <td scope="col" data-rpa-tag-id="fiveYrPctBenchmkAfterTaxOnDistributionFundShares">
                            {{data?.benchmark?.afterTaxOnDistributionFundShares?.fiveYrPct | VMFPercent | DashIfEmpty}}
                        </td>
                        <td scope="col" data-rpa-tag-id="tenYrPctBenchmkAfterTaxOnDistributionFundShares">
                            {{data?.benchmark?.afterTaxOnDistributionFundShares?.tenYrPct | VMFPercent | DashIfEmpty}}
                        </td>
                        <td scope="col" data-rpa-tag-id="inceptionPercentageBenchmkAfterTaxOnDistributionFundShares">
                            {{data?.benchmark?.afterTaxOnDistributionFundShares?.sinceInceptionPct | VMFPercent |
                            DashIfEmpty}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="after-tax-return-link">
        <p><a class="link dialog-button" href="javascript:void(0)" role="button"
                aria-describedby="afterTaxReturnsPopupDialogDesc"
                (click)="quarterlyAfterTaxDialog.openModalDialog();">Learn more about after-tax returns</a></p>
    </div>
</div>

<ng-template #noData>
    <div *ngIf="!data?.asOfDate" class="after-tax-return-link">
        <p class='no-data'>This information is temporarily unavailable.</p>
    </div>
</ng-template>

<c11n-modal-dialog
    modalId="quarterlyAfterTaxDialog"
    headingText="Learn more about after-tax returns"
    #quarterlyAfterTaxDialog>
    <div c11n-modal-dialog-body>
        <p [innerHTML]="afterTaxReturns?.contentValue"></p>
    </div>
</c11n-modal-dialog>